(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.v8-exact-nav details').forEach(function(item){item.addEventListener('toggle',function(){if(item.open)document.querySelectorAll('.v8-exact-nav details').forEach(function(other){if(other!==item)other.open=false;});});});document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.v8-exact-head details').forEach(function(item){item.open=false;});});document.addEventListener('click',function(event){if(!event.target.closest('.v8-exact-head'))document.querySelectorAll('.v8-exact-head details').forEach(function(item){item.open=false;});});

  } catch(e) { console.error(e); }
})();
})();
